export function createWebhookV1(send) {
  return (body, ...args) =>
    send(
      {
        path: '/v1/webhooks',
        pathParameters: {},
        type: 'post',
        query: undefined,
        body: body,
        headers: undefined,
        auth: 'oauth2',
        contentType: 'application/json',
      },
      ...args
    );
}
